import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';

export const DeliveryNotesDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  deliveryNotes: [],
};

export const DeliveryNotesPropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
  deliveryNotes: PropTypes.arrayOf(PropTypes.number),
  orderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};
